import React from 'react'

import InfoPanelLabel from "./info-panel-label"
import ControlButtonStandard, {
    ControlButtonType
} from "../../gd-components/buttons/control-button/control-button-standard";

type Props = {
    icon?           : string
    label?          : string
    contentClass?   : string
    onRemove?       : callback
    className?      : string
    labelClassName? : string
    children?       : any
}

export default function InfoPanelRow(props:Props) {
    return (
        <div className={Classes("ip-section-row", props.className)}>
            <InfoPanelLabel className   = {props.labelClassName}
                            icon        = {props.icon}
                            label       = {props.label}
                            enableHint  = {true} />
            <div className={Classes("ip-content", props.contentClass)}>
                {props.children}

                {!!props.onRemove &&
                    <ControlButtonStandard type={ControlButtonType.DELETE} onClick={props.onRemove} className="ip-content-trash m-l-8" hint="Delete custom field" />
                }
            </div>
        </div>
    )
}

